import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  AddProducts,
  GetProductById,
  UpdateProduct,
} from "../../services/productService";
import CommonMessage from "../../common/CommonMessage";

const AddProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const isEdit = !!id;

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    sku: "",
    price: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
  if (!isEdit) return;

  const loadProduct = async () => {
    try {
      setLoading(true);

      const response = await GetProductById(id);

      if (response?.success) {
        const data = response.data;

        setFormData({
          name: data.name,
          sku: data.sku,
          price: data.originPrice,
        });
      }
    } catch (err) {
      console.log(err);
      setMessage("Unable to load product.");
    } finally {
      setLoading(false);
    }
  };

  loadProduct();
}, [id, isEdit]);

  const fields = [
    {
      label: "Name",
      name: "name",
      type: "text",
      placeholder: "Enter Product Name",
    },
    {
      label: "SKU",
      name: "sku",
      type: "text",
      placeholder: "Enter SKU",
    },
    {
      label: "Price",
      name: "price",
      type: "number",
      placeholder: "Enter Price",
    },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validate = () => {
    let newErrors = {};

    if (!(formData.name || "").trim()) {
  newErrors.name = "Product Name is required.";
}

if (!(formData.sku || "").trim()) {
  newErrors.sku = "SKU is required.";
}

    if (formData.price === "")
      newErrors.price = "Price is required.";
    else if (Number(formData.price) <= 0)
      newErrors.price = "Price must be greater than 0.";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormData({
      name: formData.name,
      sku: formData.sku,
      price: formData.price,
    });

    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    const payload = {
      id:id,
      name: (formData.name || "").trim(),
  sku: (formData.sku || "").trim(),
  originPrice: Number(formData.price),
    };

    try {
      let response;

      if (isEdit) {
        response = await UpdateProduct(payload);
      } else {
        response = await AddProducts(payload);
      }

      if (response?.statusCode === 200) {
        setMessage(
          isEdit
            ? "Product updated successfully."
            : "Product added successfully."
        );

        if (isEdit) {
          setTimeout(() => navigate("/lstproduct"), 1000);
        } else {
          resetForm();
        }
      } else {
        setMessage(response?.message || "Something went wrong.");
      }
    } catch (err) {
      console.log(err);
      setMessage("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {message && <CommonMessage text={message} />}

      <form onSubmit={handleSubmit}>
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="custom-card">
              <div className="card-header-red">
                {isEdit ? "Edit Product" : "Add Product"}
              </div>

              <div className="card-body-custom">
                {fields.map((field) => (
                  <div className="mb-3" key={field.name}>
                    <label className="form-label">
                      {field.label}
                    </label>

                    <input
                      type={field.type}
                      name={field.name}
                      className={`form-control ${
                        errors[field.name] ? "is-invalid" : ""
                      }`}
                      value={formData[field.name]}
                      placeholder={field.placeholder}
                      onChange={handleChange}
                    />

                    {errors[field.name] && (
                      <div className="invalid-feedback">
                        {errors[field.name]}
                      </div>
                    )}
                  </div>
                ))}

                <button
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading
                    ? isEdit
                      ? "Updating..."
                      : "Saving..."
                    : isEdit
                    ? "Update"
                    : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default AddProduct;